import { Outlet } from 'react-router-dom'

const ProfileOutlet = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default ProfileOutlet